import { render, staticRenderFns } from "./TruncateXeroIdsButton.vue?vue&type=template&id=3da8c5fb&"
import script from "./TruncateXeroIdsButton.vue?vue&type=script&lang=js&"
export * from "./TruncateXeroIdsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports